import script from "./VDatePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./VDatePicker.vue?vue&type=script&setup=true&lang=js"

import "./VDatePicker.vue?vue&type=style&index=0&id=202980e4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-202980e4"]])

export default __exports__